import {
  mergeCodeProductsIntoTenantStore,
  registerProductsFromTenantStore
} from "./chunk-3YBVQZRI.js";
import {
  runTenantProductMigration
} from "./chunk-N6I6VNBJ.js";
import {
  loadTenantStore,
  userCatalogToCustomProducts
} from "./chunk-3TOUJ5O5.js";

// src/tenant-products/hydrate.ts
function hydrateTenantProducts(options) {
  const { customProducts, codeProducts = [] } = options;
  const { customProducts: migratedMirror } = runTenantProductMigration(customProducts);
  if (codeProducts.length > 0) {
    mergeCodeProductsIntoTenantStore(codeProducts);
  }
  registerProductsFromTenantStore();
  const catalogMirror = userCatalogToCustomProducts(loadTenantStore().catalog);
  const mirror = catalogMirror.length > 0 ? catalogMirror : migratedMirror.length > 0 ? migratedMirror : [];
  return { customProducts: mirror };
}

export {
  hydrateTenantProducts
};
